export interface ActionType{
  title: string;
  tipo: string;
  answer?: string
}

export const UPDATE:ActionType = {
  title:"Editar Parte",
  tipo:"U",
  answer:"Vas a actualizar el parte de otro usuario.\n ¿Seguir con la acción?"
}

export const UPDATE_FINSEMANA:ActionType = {
  title:"Editar Parte (Solo fin de semana)",
  tipo:"UFS",
  answer:"Vas a actualizar el parte de otro usuario.\n ¿Seguir con la acción?"
}

export const CREATE: ActionType = {
  title:"Crear Parte (Solo días laborables)",
  tipo:"I",
  answer:"Vas a crear un parte para otro usuario.\n¿Seguir con la acción?"
}

export const CREATE_FINSEMANA: ActionType = {
  title:"Crear Parte (Solo fin de semana)",
  tipo:"IFS",
  answer:"Vas a crear un parte para otro usuario.\n¿Seguir con la acción?"
}

export const ADJUNTAR: ActionType = {
  title:"Adjuntar archivos",
  tipo:"A"
}

export const UPLOAD: ActionType = {
  title:"Importar Partes",
  tipo:"UF"
}

export const REMOVE: ActionType = {
  title:"Eliminar Partes",
  tipo:"R",
  answer:"Vas ha eliminar parte(s).\n¿Seguir con la acción?"
}

export const ESTADOS = {
  RESPONSABLE_AREA: 1,
  FISCAL: 2,
  FACTURACION: 3,
  FACTURADO: 4,
  FIN_SEMANA: 5,
  TODOS: 6
}

export const USER_PERMISSIONS = {
  'USR':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION],
    'editar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION,ESTADOS.TODOS],
    'eliminar': [ESTADOS.RESPONSABLE_AREA, ESTADOS.FIN_SEMANA]
  },
  'RRH':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION],
    'editar': [ESTADOS.RESPONSABLE_AREA],
    'eliminar': [ESTADOS.RESPONSABLE_AREA, ESTADOS.FIN_SEMANA]
  },
  'RAR':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION],
    'editar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION,ESTADOS.TODOS],
    'eliminar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FIN_SEMANA]
  },
  'FIS':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION],
    'editar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION,ESTADOS.TODOS],
    'eliminar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FIN_SEMANA]
  },
  'FAC':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION],
    'editar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION,ESTADOS.TODOS],
    'eliminar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FIN_SEMANA]
  },
  'ADM':{
    'adjuntar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION,ESTADOS.TODOS],
    'editar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FACTURACION,ESTADOS.TODOS],
    'eliminar': [ESTADOS.RESPONSABLE_AREA,ESTADOS.FISCAL,ESTADOS.FIN_SEMANA,ESTADOS.FACTURACION,ESTADOS.TODOS]
  },
}

export const bloquear = true;